import { PropertyClassType } from '../domain/types';

export const propertyClassTypeLabels: Record<PropertyClassType, string> = {
  LUXURY: 'Di lusso',
  ELEGANT: 'Signorile',
  STANDARD: 'Media',
  ECONOMIC: 'Economica',
};
